import { State } from 'src/types'
import { fingerStand } from '../fingerStand'
import { beltStyleDrawer } from './beltStyleDrawer'

export const backStyleDrawer = (ctx: CanvasRenderingContext2D, state: State): void => {
  fingerStand(ctx, state.fingerStand?.color, state.stitch?.color)
  // ベルトバックスタイル
  beltStyleDrawer(ctx, state)
}
